import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import {
  Artist,
  ArtistMedia,
  Dashboard,
  Song,
  SongListitem,
  Upload,
  User,
  Video,
  YouTubeVideo,
} from '../@types/api';

const { persistAtom } = recoilPersist();

export const dashboardState = atom({
  key: 'dashboard',
  default: undefined as Dashboard | undefined,
});

export const artistsState = atom({
  key: 'artists',
  default: [],
});

export const liveArtistsState = atom({
  key: 'liveArtists',
  default: [],
});

export const stylesState = atom({
  key: 'styles',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const pageSizeState = atom({
  key: 'pageSize',
  default: 10,
  effects_UNSTABLE: [persistAtom],
});

export const paginationModelState = atom({
  key: 'paginationModel',
  default: {
    pageSize: 25,
    page: 0,
  },
  effects_UNSTABLE: [persistAtom],
});

export const userState = atom({
  key: 'user',
  default: undefined as User | undefined,
  effects_UNSTABLE: [persistAtom],
});

export const loadingState = atom({
  key: 'loading',
  default: false as boolean,
});

export const songOptionsState = atom({
  key: 'songOptions',
  default: undefined as Song[] | undefined,
});

export const artistState = atom({
  key: 'artist',
  default: undefined as Artist | undefined,
});

export const galleryState = atom({
  key: 'gallery',
  default: undefined as ArtistMedia[] | undefined,
});

export const videosState = atom({
  key: 'videos',
  default: undefined as Video[] | undefined,
});

export const songlistState = atom({
  key: 'songlist',
  default: undefined as SongListitem[] | undefined,
});

export const audioState = atom({
  key: 'audio',
  default: undefined as ArtistMedia[] | undefined,
});

export const uploadsState = atom({
  key: 'uploads',
  default: undefined as Upload[] | undefined,
});

export const youTubeVideosState = atom({
  key: 'youTubeVideos',
  default: undefined as YouTubeVideo[] | undefined,
});

export const toastState = atom({
  key: 'toast',
  default: undefined as string | undefined,
});
